const trialFilters = (): void => {
  let dataFilters: any = {};
  const allowMultipleOptions = true;
  const url = document.querySelector('html').getAttribute('data-base-url');

  const setActiveFilters = (): void => {
    const queryString = window.location.search;
    dataFilters = Object.fromEntries(new URLSearchParams(queryString));

    for (const [dataFilterKey, dataFilterValue] of Object.entries(
      dataFilters
    )) {
      const filterElements = document.querySelectorAll(
        '[data-filter][data-filter-key="' + dataFilterKey + '"]'
      );
      filterElements.forEach((element: any) => {
        const elementType = element.getAttribute('data-filter-type');
        const elementValue = element.getAttribute('data-filter-value');

        if (elementType == 'button') {
          if (allowMultipleOptions) {
            if (dataFilterValue && typeof dataFilterValue === 'string') {
              const dataFilterValueArr = dataFilterValue.split(',');
              dataFilterValueArr.forEach((singleValue) => {
                if (singleValue == elementValue) {
                  element.setAttribute('selected', 'selected');
                }
              });
            }
          } else {
            if (elementValue == dataFilterValue) {
              element.setAttribute('selected', 'selected');
            } else {
              element.removeAttribute('selected');
            }
          }
        }
        if (elementType == 'select') {
          const elementOptions = element.querySelectorAll('option');
          const matchingFilterOption = element.querySelector(
            '[value="' + dataFilterValue + '"]'
          );
          if (matchingFilterOption) {
            elementOptions.forEach((option: any) => {
              option.removeAttribute('selected');
            });
            matchingFilterOption.setAttribute('selected', 'selected');
            element.value = dataFilterValue;
          }
        }
      });
    }
  };

  setActiveFilters();

  const loadPage = (): void => {
    let dataFiltersString = url + '?';
    for (const [key, value] of Object.entries(dataFilters)) {
      dataFiltersString = dataFiltersString + key + '=' + value + '&';
    }
    dataFiltersString = dataFiltersString.substring(
      0,
      dataFiltersString.length - 1
    );
    window.location.href = dataFiltersString + '#trials';
  };

  const applyFilters = (filterKey: string, filterValue: string): void => {
    if (allowMultipleOptions) {
      if (Array.isArray(dataFilters[filterKey])) {
        dataFilters[filterKey].push(filterValue);
      } else if (dataFilters[filterKey]) {
        dataFilters[filterKey] = [dataFilters[filterKey], filterValue];
      } else {
        dataFilters[filterKey] = [filterValue];
      }
    } else {
      dataFilters[filterKey] = filterValue;
    }

    loadPage();
  };

  const clearFilter = (filterKey: string, filterValue: string): void => {
    if (allowMultipleOptions) {
      if (dataFilters[filterKey]) {
        const filterValuesArr = dataFilters[filterKey].split(',');
        if (
          filterValuesArr.length === 1 &&
          filterValuesArr[0] === filterValue
        ) {
          delete dataFilters[filterKey];
        } else {
          dataFilters[filterKey] = filterValuesArr.filter(
            (item: string) => item !== filterValue
          );
        }
      }
    } else {
      if (dataFilters[filterKey]) {
        delete dataFilters[filterKey];
      }
    }

    loadPage();
  };

  const filters: any = document.querySelectorAll('[data-filter]');

  filters.forEach((filter: any) => {
    const filterType = filter.getAttribute('data-filter-type');
    if (filterType == 'button') {
      filter.addEventListener('click', () => {
        const filterKey = filter.getAttribute('data-filter-key');
        const filterValue = filter.getAttribute('data-filter-value');
        const filterStatus = filter.getAttribute('selected');
        if (filterStatus == 'selected' || filterValue == 'clear-filter') {
          clearFilter(filterKey, filterValue);
        } else {
          applyFilters(filterKey, filterValue);
        }
      });
    }
    if (filterType == 'select') {
      filter.addEventListener('change', () => {
        const filterKey = filter.getAttribute('data-filter-key');
        const filterValue = filter.options[filter.selectedIndex].value;
        if (filterValue == 'clear-filter') {
          clearFilter(filterKey, filterValue);
        } else {
          applyFilters(filterKey, filterValue);
        }
      });
    }
  });

  // Filter Accordions

  const classes = {
    accordionOpen: 'filters__buttons--open',
    accordionOpenOnLoad: 'filters__buttons--open-on-load',
  };

  const selectors = {
    accordionItem: '[data-filter-buttons-accordion]',
    accordionItemTitle: '[data-filter-buttons-accordion-title]',
    accordionItemContent: '[data-filter-buttons-accordion-content]',
  };

  const openAccordion = (accordion: HTMLElement): void => {
    const content = accordion.querySelector<HTMLElement>(
      selectors.accordionItemContent
    );
    accordion.classList.add(classes.accordionOpen);
    content.style.maxHeight = content.scrollHeight + 'px';
  };

  const closeAccordion = (accordion: HTMLElement): void => {
    const content = accordion.querySelector<HTMLElement>(
      selectors.accordionItemContent
    );
    accordion.classList.remove(classes.accordionOpen);
    content.style.maxHeight = null;
  };

  const accordions = document.querySelectorAll<HTMLElement>(
    selectors.accordionItem
  );

  accordions.forEach((accordion) => {
    const title = accordion.querySelector<HTMLButtonElement>(
      selectors.accordionItemTitle
    );
    const content = accordion.querySelector<HTMLElement>(
      selectors.accordionItemContent
    );

    if (title && content) {
      title.onclick = (): void => {
        if (accordion.classList.contains(classes.accordionOpen)) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion);
        }
      };

      if (accordion.classList.contains(classes.accordionOpenOnLoad)) {
        content.style.maxHeight = content.scrollHeight + 'px';
        accordion.classList.remove(classes.accordionOpenOnLoad);
      }
    }
  });
};

export default trialFilters;
